export type Amount = { displayText: string } | { min: number; max: number | null };

export const CUSTOM_FEE_TYPE = 'CUSTOM';

export interface FeeOption {
  displayName: string;
  amount: Amount;
}

export enum CurrencyType {
  CAD = 'CAD',
  USD = 'USD',
}

export interface Counter {
  min: number;
  max: number | null;
}

export interface Fee {
  type: string;
  displayName: string;
  zillowDisclaimers: string[];
  partnerDisclaimer: string;
  amount: Amount;
  counter: Counter;
  options: FeeOption[];
}

export interface FeeGroup {
  type: string;
  displayName: string | null;
  fees: Fee[];
}

export interface FeeSection {
  displayName: string | null;
  // subText: string | null; // Not used by HPWEB?
  feeGroup: FeeGroup[];
}

export interface CostTotals {
  moveIn: CostTotal;
  monthly: CostTotal;
  baseRent: CostTotal;
  oneTime?: CostTotal; // Making this optional since we're adding it dynamically
}

export interface CostTotal {
  displayName: string;
  amount: Amount;
}

export interface Selector {
  displayName: string;
  costs: CostTotals;
  feeOverrides: AllFees;
}

export interface BedSelector {
  numBeds: number;
  selector: Selector;
}

export interface UnitSelector {
  unitZpid: string;
  numBeds: number;
  selector: Selector;
}

export interface UnitSelectorWithAdditional extends UnitSelector {
  availableFrom?: string;
  numBaths?: number;
  isRepresentative?: boolean;
  hdpUrl?: string;
  floorplanZpid?: string;
  studentHousingType?: string | null;
  price?: number;
}

export interface AllSelectors {
  beds: BedSelector[];
  units: UnitSelector[];
}

export interface AllFees {
  moveIn: FeeSection;
  monthly: FeeSection;
  whenUsed: FeeSection;
}

export interface PriceData {
  costs: CostTotal;
  fees: FeeSection;
}

export interface CostsAndFees {
  costs: CostTotals;
  fees: AllFees;
  selectors: AllSelectors;
  disclaimer: string;
}

export interface FloorPlan {
  zpid: string;
  baths: number;
  availableFrom: string;
  units: FloorPlanUnit[] | null;
  beds: number;
  maxPrice?: number | null;
  minPrice?: number | null;
}

export interface FloorPlanUnit {
  availableFrom: string;
  zpid: string;
  price?: number | null;
  studentHousingType?: string | null;
}

// Handle calculations

export interface FeeOverrides {
  moveIn?: FeeSection;
  monthly?: FeeSection;
  whenUsed?: FeeSection;
}

export interface FlattenedFee extends Fee {
  frequency: string;
  feeGroupType: string;
  frequencyDisplayName: string;
  frequencySubText: string;
  feeGroupDisplayName: string;
}

// UI Types for dynamic calculations

export interface SelectedFeeOption {
  counterValue: number;
  optionSelected?: string | null;
  expiresOn?: number;
}

export interface SelectedFeeOptions {
  [type: string]: SelectedFeeOption;
}

export interface UngroupedUnit {
  zpid: string;
  baths: number;
  beds: number;
  availableFrom: string;
  // listingType: ListingType;
  price: number;
  hdpUrl: string;
}
